import { render } from "./ResponsesStats.vue?vue&type=template&id=0ed81d13"
import script from "./ResponsesStats.vue?vue&type=script&lang=js"
export * from "./ResponsesStats.vue?vue&type=script&lang=js"

import "./ResponsesStats.vue?vue&type=style&index=0&id=0ed81d13&lang=scss"
script.render = render

export default script